export default "__VITE_ASSET__CDUaSkFG__"